import { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router';

import { getKameleoonFeatureFlag } from 'PublicApis';

import { UserContext } from 'Context/user';

import {
  DEFAULT_FEATURE_FLAGS,
  FEATURE_FLAG_NAME,
  FeatureFlagName,
  FeatureFlagNameMap,
  FeatureFlagsType,
} from '../featureFlags';

export const useFetchFeatureFlag = <T extends FeatureFlagName>(
  getName: (flagNames: FeatureFlagNameMap) => T,
  condition?: boolean,
): FeatureFlagsType[T] | null => {
  const { userState: user } = useContext(UserContext);
  const [value, setValue] = useState<FeatureFlagsType[T] | null>(null);

  const flagName = getName(FEATURE_FLAG_NAME);

  const defaultValue = DEFAULT_FEATURE_FLAGS[flagName];

  const { pathname } = useLocation();

  useEffect(() => {
    if (condition === false) {
      setValue(defaultValue);
      return;
    }

    const updateValue = async () =>
      setValue(
        await getKameleoonFeatureFlag({
          flagName,
          pathname,
          userId: user?.id?.toString(),
        }).catch((err) => {
          window?.Sentry?.captureException?.(new Error(err), {
            level: 'error',
            tags: {
              fetch: 'Kameleoon feature flag',
            },
          });
          return defaultValue;
        }),
      );

    updateValue();
  }, [pathname, flagName, defaultValue, condition, user?.id]);

  return value;
};
